import React from 'react';
import { useNavigate } from 'react-router-dom';
import eImg from '../../../img/Casung1.jpeg';
import jImg from '../../../img/Casung2.jpeg';
import lImg from '../../../img/Casung3.jpeg';
import mImg from '../../../img/Casung4.jpeg';
import nImg from '../../../img/Casung5.jpeg';
import oImg from '../../../img/Casung6.jpeg';
import pImg from '../../../img/Casung7.jpeg';

const ProductsCasung = () => {
  const navigate = useNavigate();

  const casungProducts = [
    {
      moldingNumber: "CA001",
      description: "Classic casing molding with a timeless design, perfect for door frames.",
      imagen: eImg
    },
    {
      moldingNumber: "CA002",
      description: "Modern casing with clean lines and a sleek finish for contemporary spaces.",
      imagen: jImg
    },
    {
      moldingNumber: "CA003",
      description: "Decorative casing with intricate details to add a unique touch to any room.",
      imagen: lImg
    },
    {
      moldingNumber: "CA004",
      description: "Rustic casing with a natural wood finish, ideal for cozy interiors.",
      imagen: mImg
    },
    {
      moldingNumber: "CA005",
      description: "Minimalist casing with a subtle profile that blends seamlessly with modern designs.",
      imagen: nImg
    },
    {
      moldingNumber: "CA006",
      description: "Luxury casing with exquisite craftsmanship for high-end projects.",
      imagen: oImg
    },
    {
      moldingNumber: "CA007",
      description: "Versatile casing suitable for various door and window styles.",
      imagen: pImg
    }
  ];

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <div className="container mx-auto px-4 py-28">
      <h1 className="text-3xl font-bold text-center mb-9 font-montserrat">Casing Molding Collection</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {casungProducts.map((product) => (
          <div
            className="bg-white rounded-lg shadow-md overflow-hidden transform transition-transform duration-300 hover:scale-105 cursor-pointer flex flex-col h-full"
            key={product.moldingNumber}
          >
            <img
              src={product.imagen}
              alt={`Casing molding ${product.moldingNumber}`}
              className="w-full h-48 object-cover"
            />
            <div className="p-4 flex flex-col flex-grow">
              <h5 className="text-xl font-semibold text-gray-800 mb-2">
                Casing Molding {product.moldingNumber}
              </h5>
              <p className="text-sm text-gray-600 leading-relaxed flex-grow">
                {product.description}
              </p>
            </div>
          </div>
        ))}

        {/* Informative Card */}
        <div
          className="md:col-span-2 bg-emerald-800 rounded-lg shadow-md p-6 flex flex-col justify-between cursor-pointer hover:bg-emerald-700 transition-colors duration-300"
          onClick={handleContactClick}
        >
          <div>
            <h5 className="text-xl font-bold text-emerald-50 mb-4">Need More Information?</h5>
            <p className="text-emerald-100 mb-4">
              Interested in our casing moldings? Want to discuss custom designs or get a quote? 
              Our team is ready to assist you in finding the perfect molding for your project.
            </p>
            <p className="text-emerald-100">
              To view the complete list of products, please register to obtain your access token (key).
            </p>
          </div>
          <div className="mt-4">
            <span className="text-emerald-50 font-semibold hover:underline">
              Contact us →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsCasung;
